import React, { useEffect } from "react";
import "./FlotingAlert.css";
import { CheckCircle, XCircle } from "lucide-react";
import success from "../../assests/success-icon.svg"

interface FloatingAlertProps {
  message: string;
  submessage?: string;
  type?: "success" | "error";
  duration?: number; // milliseconds
  onClose: () => void;
}

const FloatingAlert: React.FC<FloatingAlertProps> = ({
  message,
  submessage,
  type = "success",
  duration = 3000,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`floating-alert ${type}`}>
            <div className="alert-contents">
        {type === "success" && <img src={success} alt="Success" className="icon-alert" />}
        {type === "error" && <XCircle size={22} className="icon-alert" />}
        <div style={{display:"flex",flexDirection:"column" ,justifyContent:"space-evenly",alignItems:"flex-start"}}>
        <span className="message-floating">{message}</span>
        <span className="submessage-floating">{submessage}</span>
        </div>
      </div>
    </div>
  );
};

export default FloatingAlert;
